import * as classnames from 'classnames';
import * as React from 'react';

import './Initial.scss';

interface InitialProps {
  className?: string;
  maxLetter?: number;
  onClick?: MSExecAtPriorityFunctionCallback;
  name: string;
}

export class Initial extends React.Component<InitialProps, {}> {
  private defaultName = '-';

  shouldComponentUpdate(props: InitialProps) {
    if (this.props.name !== props.name) return true;
    return false;
  }

  render() {
    const { className, maxLetter, name, ...rest } = this.props;
    const backgroundColor = this.intToRGB(this.hashCode(name));
    const computedStyle = {
      backgroundColor: '#' + backgroundColor,
      color: '#' + this.luminate(backgroundColor)
    };
    return (
      <div className={classnames('initial', className)} style={computedStyle} {...rest}>
        {this.getInitial(name, maxLetter)}
      </div>
    );
  }

  private getInitial(name: string, maxLetter = 2) {
    return this.split(name).substring(0, maxLetter);
  }

  private split(name: string) {
    const initials = name.match(/\b\w/g) || [this.defaultName];
    return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
  }

  private hashCode(name: string) {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  }

  private intToRGB(numeric: number) {
    const c = (numeric & 0x00FFFFFF)
        .toString(16)
        .toUpperCase();

    return '00000'.substring(0, 6 - c.length) + c;
  }

  private luminate(color: string) {
    const rgb = parseInt(color, 16);
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >>  8) & 0xff;
    const b = (rgb >>  0) & 0xff;

    const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b;

    if (luma < 200) {
      return 'ffffff';
    }

    return undefined;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Initial/Initial.tsx